export const DEFAULT_MEMBER_PROGRAM_DISCOUNT = 20;

export const isIncludedWithMembership = (program) => {
  if (!program || program.isSubscription) return false;
  if (program.includedWithMembership === true) return true;
  const amount = Number(program.amount);
  return !Number.isFinite(amount) || amount === 0;
};

export const getMemberDiscountPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return DEFAULT_MEMBER_PROGRAM_DISCOUNT;
  if (n > 100) return 100;
  return n;
};

export const getNonMemberPrice = (program) => {
  if (program?.nonMemberAmount != null) return Number(program.nonMemberAmount);
  return Number(program?.amount) || 0;
};

export const getMemberPrice = (program, discountPercent) => {
  if (isIncludedWithMembership(program)) return 0;
  if (program?.memberAmount != null) return Number(program.memberAmount);
  const amount = getNonMemberPrice(program);
  const pct = getMemberDiscountPercent(discountPercent);
  return Math.round(amount * (1 - pct / 100) * 100) / 100;
};

export const formatProgramPrice = (amount, currency = "usd") => {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const code = String(currency || "usd").toLowerCase();
  const symbol = code === "usd" ? "$" : `${code.toUpperCase()} `;
  const formatted = Number.isInteger(n) ? String(n) : n.toFixed(2);
  return `${symbol}${formatted}`;
};

/** Decode &lt; &gt; (and double-encoded) markup from Admin / LMS HTML. */
export const decodeMaybeEncodedHtml = (value) => {
  let html = String(value || "");
  if (!html) return "";
  for (let i = 0; i < 3; i += 1) {
    if (!html.includes("&lt;") && !html.includes("&amp;") && !html.includes("&#")) {
      break;
    }
    if (typeof document === "undefined") {
      const next = html
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&");
      if (next === html) break;
      html = next;
      continue;
    }
    const textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    if (textarea.value === html) break;
    html = textarea.value;
  }
  return html;
};

export const stripHtml = (value) =>
  decodeMaybeEncodedHtml(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/** HTML for the Details modal: real markup, no buy buttons. */
export const programDetailsHtml = (value, { stripImages = false } = {}) => {
  const decoded = decodeMaybeEncodedHtml(value);
  if (!decoded) return "";
  if (typeof DOMParser === "undefined") {
    return decoded.replace(/<script[\s\S]*?<\/script>/gi, "");
  }
  const doc = new DOMParser().parseFromString(decoded, "text/html");
  doc
    .querySelectorAll("script, style, button, .buy-now-button")
    .forEach((el) => el.remove());
  doc.querySelectorAll("img").forEach((img) => {
    if (stripImages) {
      img.remove();
      return;
    }
    img.removeAttribute("width");
    img.removeAttribute("height");
    img.style.maxWidth = "100%";
    img.style.height = "auto";
    img.style.display = "block";
    img.style.margin = "12px auto";
  });
  return String(doc.body?.innerHTML || "").trim();
};

export const programTopic = (program) => {
  const names = program?.wordpressCategoryName;
  const raw = Array.isArray(names)
    ? String(names[0] || "")
    : typeof names === "string"
      ? names.split(",")[0]
      : "";
  const topic = raw.trim();
  if (!topic || /^default category$/i.test(topic)) return "";
  return topic;
};

export const programTeacher = (program) => {
  const teacher =
    program?.teacher ||
    program?.teacherName ||
    program?.instructor ||
    "";
  return String(teacher).trim();
};
